module.exports = __webpack_public_path__ + "static/media/search-products-icon.d25564b2.svg";